/*
 * Global module
 * @module global/index
 **/
// Note: this file incurs side-effects when loading ie setting variables on the
// global object

// Essential global modules
import * as checkbrowser from '../checkbrowser/init.js';
// import * as datalayer from '../datalayer/index.js';
import * as save_page_storage from '../save_page_storage/init.js';
// import * as chat from '../chat/init.js';
// Simple global modules
// import * as addon_click from './addon_click.js';
// import * as bsb from './bsb.js';
import * as checkbox from './checkbox.js';
import * as datepicker from './datepicker.js';
// import * as donation from './donation.js';
import * as field from './field.js';
// import * as gc_card from '../gift_catalogue/card/init.js';
import * as gclogic from '../gift_catalogue/logic/controller.js';
//import * as gc_giving_card from '../gift_catalogue/giving_card.js';
import * as header from './header.js';
import * as image_gallery from './image_gallery.js';
import * as inject from '../sponsorship/inject.js';
import * as playvideo from './playvideo.js';
import * as product_quantity from '../product/quantity/init.js';
import * as recently_viewed from './recently_viewed.js';
import * as recommended from './recommended.js';
import * as reveal_toggle from './revealToggle.js';
import * as search from './search.js';
import * as select_variant from './select_variant.js';
import * as slider from './slider.js';
import * as smoothscroll from './smoothscroll.js';
// import * as sort_collection from '../util/sort_collection.js';
import * as tab from './tab.js';
import * as url from '../util/url/init.js';
import * as validate from './validate.js';
import * as validate_price from './validate_price.js';

// Global components
// import * as sponsorship from '../sponsorship/init.js';

// Global modules that can load whenever
import * as motcodeman from '../motcode_manager/init.js';

// Local imports
import * as lib from './lib.js';

// Setup svg icons
// Note: this uses ES5 module syntax as webpack-svgstore-plugin is ES5 only
export const __svg__ = {
    path: '../../icons/**/*.svg',
    name: 'snippets/icons.svg.liquid',
};
// require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

// Re-export the initialize function
export const initialize = lib.initialize;

// All modules defining global variables
// The url module sets up url parsing
export let __all__ = [
    // Globals that need to load first
    checkbrowser,
    // page info,
    save_page_storage,
    // Simple global modules
    url,
    header,
    slider,
    reveal_toggle,
    // sponsorship, <= this is being run by the spsh page entrypoints
    // donation,    <= this is being run by the sghome page entrypoint
    playvideo,
    // bsb, <= this is being run by the bsb page entrypoint
    smoothscroll,
    // basket, <= this is being run by the basket page entrypoint
    validate,
    inject,
    field,
    validate_price,
    // addon_click, <= this is being run by gc_giving_card page entrypoint
    product_quantity,
    tab,
    datepicker,
    image_gallery,
    checkbox,
    gclogic,
    select_variant,
    recently_viewed,
    recommended,
    //gc_giving_card,
    // sort_collection, <= only run on gcall and gccategory pages
    // gc_card,
    search,

    // Globals that can load whenever
    motcodeman,
];
